import Header from "./components/header";
import url from "./assets/perfil.jpg";
import Contact from "./components/contact";
import { FiGithub, FiMail } from "react-icons/fi";
import { FaCss3, FaHtml5, FaLinkedinIn, FaSass } from "react-icons/fa";
import {
  BiLogoTypescript,
  BiLogoJavascript,
  BiLogoReact,
  BiMobileAlt,
  BiLogoRedux,
  BiLogoGit,
  BiLogoTailwindCss,
} from "react-icons/bi";
import { useEffect } from "react";
import Skill from "./components/skill";
import Card from "./components/card";
import Experience from "./components/experience";
import Education from "./components/education";
import ParticlesBackground from "./components/ParticlesBackground";
import ScrollProgress from "./components/ScrollProgress";
import TypewriterText from "./components/TypewriterText";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  useEffect(() => {
    animateScroll();
    window.addEventListener("scroll", animateScroll);
  }, []);

  const totalExperience = getTotalYears('2019-06-01');
  const currentExperience = calculateExperience('2021-08-01');

  return (
    <div className="relative bg-gradient-to-br from-zinc-900 via-zinc-900 to-blue-900/20 font-mono h-full min-h-screen overflow-x-hidden">
      <ParticlesBackground />
      <ScrollProgress />
      <Header />
      <div className="overflow-y-auto">
        <div
          className="relative mx-6 lg:mx-44 mb-6 lg:mb-20 mt-28 lg:mt-36 flex flex-col-reverse lg:flex-row justify-between align-center opacity-0 -translate-x-40 transition duration-200 js-show-on-scroll"
          id="home"
        >
          <div className="text-center lg:text-start self-center z-10">
            <h2 className="text-white text-2xl lg:text-4xl tracking-tight mb-2">
              {identHours()}, me chamo
            </h2>
            <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-blue-400 to-purple-400 text-4xl lg:text-6xl font-bold tracking-tight mb-4 animate-gradient">
              Gean Carlos Nunes
            </h2>
            <h2 className="text-zinc-200 text-xl lg:text-2xl mb-2">
              <TypewriterText 
                texts={[
                  "Desenvolvedor Sênior Full Stack",
                  "Liderança Técnica",
                  "Liderança de Equipe",
                  "Frontend Specialist",
                  "React & React Native Developer"
                ]}
              />
            </h2>
          </div>
          <div className="self-center z-10">
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-green-500 via-blue-500 to-purple-500 rounded-full blur-2xl opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-[wiggle_15s_ease-in-out_infinite]"></div>
              <img
                src={url}
                alt="Gean Carlos Nunes"
                className="relative h-60 lg:h-96 w-52 lg:w-80 mb-6 lg:mb-0 object-cover shadow-2xl animate-[wiggle_15s_ease-in-out_infinite] transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </div>
        </div>
        <Card
          title={"Sobre mim"}
          id="about"
          className={"justify-between align-center text-base lg:text-lg"}
        >
          <p className="text-white text-center pb-2">
            Desenvolvedor de software com mais de {totalExperience} anos de experiência, atuando como full stack e exercendo liderança técnica em equipes de desenvolvimento. Possuo forte atuação no ecossistema JavaScript/TypeScript, incluindo React, React Native, Next.js e Node.js, com experiência sólida no desenvolvimento de aplicações web e mobile escaláveis.
          </p>
          <p className="text-white text-center pb-2">
            No backend, trabalho com arquiteturas baseadas em APIs, utilizando principalmente Node.js (NestJS) e Python, com integração a bancos de dados relacionais e não relacionais (SQL e NoSQL), modelagem de dados e construção de serviços orientados a desempenho, segurança e manutenibilidade.
          </p>
          <p className="text-white text-center pb-2">
            Atuo diretamente na condução técnica de projetos ponta a ponta, desde o entendimento das demandas com clientes e stakeholders, definição de arquitetura, planejamento de sprints e divisão de tarefas, até o desenvolvimento, deploy em produção e acompanhamento pós-entrega.
          </p>
          <p className="text-white text-center">
            Tenho perfil analítico, foco em qualidade de software, boas práticas de engenharia, padronização de código e evolução técnica dos times, contribuindo para entregas consistentes, sustentáveis e alinhadas aos objetivos de negócio.
          </p>
        </Card>
        <Card title={"Habilidades"} id="skills">
          <div className="flex flex-row flex-wrap justify-center">
            <Skill icon={<FaHtml5 />} title={"HTML"} level={95} />
            <Skill icon={<FaCss3 />} title={"CSS"} level={90} />
            <Skill icon={<BiLogoJavascript />} title={"JavaScript"} level={92} />
            <Skill icon={<BiLogoTypescript />} title={"TypeScript"} level={88} />
            <Skill icon={<BiLogoReact />} title={"React"} level={90} />
            <Skill icon={<BiMobileAlt />} title={"React Native"} level={85} />
            <Skill icon={<FaSass />} title={"SASS"} level={80} />
            <Skill icon={<BiLogoTailwindCss />} title={"Tailwind"} level={88} />
            <Skill icon={<BiLogoRedux />} title={"Redux"} level={82} />
            <Skill icon={<BiLogoGit />} title={"Git"} level={85} />
          </div>
        </Card>
        {/* <Card title={"Projetos"} id="projects">
          <div className="flex flex-wrap gap-6 justify-center">
            <ProjectCard
              title="Portfolio Interativo"
              description="Portfolio pessoal com animações modernas, efeitos visuais e design responsivo."
              technologies={["React", "TailwindCSS", "JavaScript"]}
              githubUrl="https://github.com/nsgean/"
            />
            <ProjectCard
              title="Projeto em Desenvolvimento"
              description="Adicione seus projetos aqui! Este é um exemplo de card de projeto com flip effect."
              technologies={["React", "TypeScript", "Node.js"]}
            />
            <ProjectCard
              title="Seu Próximo Projeto"
              description="Mostre seus trabalhos mais impressionantes e chame a atenção de recrutadores."
              technologies={["React Native", "Redux", "API"]}
            />
          </div>
        </Card> */}
        <Card title={"Minhas experiências"} id="experiences">
          <div className="flex flex-col">
            <Experience
              time={`Ago 2021 até o momento · ${currentExperience}`}
              title="Desenvolvedor de software | Team Leader"
              company="Laev"
              location="Remota"
              description="Atuação como desenvolvedor sênior e líder técnico, responsável por conduzir decisões técnicas e garantir a qualidade das entregas do time."
              responsibilities={[
                "Liderança técnica de equipe de desenvolvimento, apoiando na definição de arquitetura, padrões de código e boas práticas.",
                "Planejamento e organização de demandas em sprints, desde o levantamento de requisitos com clientes até a entrega em produção.",
                "Atuação direta como ponto focal técnico junto a stakeholders e clientes.",
                "Desenvolvimento full stack utilizando o ecossistema JavaScript/TypeScript (React, React Native, Next.js e Node.js/NestJS).",
                "Desenvolvimento de serviços backend também em Python.",
                "Modelagem e integração com bancos de dados SQL e NoSQL.",
                "Responsável por processos de deploy, configuração de ambientes e estabilidade das aplicações em produção (GCP).",
                "Mentoria técnica para desenvolvedores do time e revisão de código contínua."
              ]}
              results={[
                "Padronização do código e melhoria da manutenibilidade dos sistemas.",
                "Aumento da previsibilidade das entregas.",
                "Evolução técnica da equipe e redução de retrabalho."
              ]}
            />
            <Experience
              time="Jul 2020 até Jul 2021 · 1 ano 1 mês"
              title="Desenvolvedor de software"
              company="Laev"
              location="Remota"
              description="Atuação como desenvolvedor full stack em projetos web e mobile."
              responsibilities={[
                "Desenvolvimento de funcionalidades frontend e backend utilizando React, Node.js e TypeScript.",
                "Construção e consumo de APIs REST.",
                "Integração com bancos de dados SQL e NoSQL.",
                "Participação ativa em decisões técnicas e melhorias de arquitetura.",
                "Colaboração com designers, produto e stakeholders para definição de soluções técnicas.",
                "Suporte a deploys e manutenção de aplicações em produção."
              ]}
            />
            <Experience
              time="Ago 2019 até Jun 2020 · 11 meses"
              title="Desenvolvedor de front-end"
              company="Laev"
              location="Governador Celso Ramos, Santa Catarina, Brasil · Presencial"
              description="Atuação no desenvolvimento de interfaces web e mobile."
              responsibilities={[
                "Desenvolvimento frontend com React e React Native.",
                "Implementação de layouts responsivos e componentização.",
                "Integração com APIs backend.",
                "Participação em code reviews e melhoria contínua do código.",
                "Colaboração com equipe de produto e backend."
              ]}
            />
          </div>
        </Card>
        <Card title={"Formação"} id="education">
          <div className="flex flex-col">
            <Education
              institution="Universidade Federal de Santa Catarina"
              degree="Bacharelado, Sistemas de Informação"
              time="Ago 2018 - Jul 2023"
              location="Florianópolis, Santa Catarina, Brasil"
            />
          </div>
        </Card>
        <Card title={"Contatos"} id="contacts">
          <div className="flex flex-row flex-wrap">
            <Contact icon={<FiMail />} title={"E-mail"} value={"geancn.dev@gmail.com"} action={'mailto:geancn.dev@gmail.com'} />
            <Contact
              icon={<FaLinkedinIn />}
              title={"Linkedin"}
              value={"nsgean"}
              action={"https://www.linkedin.com/in/nsgean"}
            />
            <Contact
              icon={<FiGithub />}
              title={"Github"}
              value={"nsgean"}
              action={"https://github.com/nsgean/"}
            />
          </div>
        </Card>
        <ScrollToTop />
      </div>
    </div>
  );
}

export default App;

function identHours() {
  const horaAtual = new Date().getHours();

  if (horaAtual >= 5 && horaAtual < 12) {
    return "Bom dia";
  } else if (horaAtual >= 12 && horaAtual < 18) {
    return "Boa tarde";
  } else {
    return "Boa noite";
  }
}

function calculateExperience(startDate) {
  const now = new Date();
  const start = new Date(startDate);
  
  let years = now.getFullYear() - start.getFullYear();
  let months = now.getMonth() - start.getMonth();
  
  if (months < 0) {
    years--;
    months += 12;
  }
  
  const yearsText = years === 1 ? 'ano' : 'anos';
  const monthsText = months === 1 ? 'mês' : 'meses';
  
  if (years > 0 && months > 0) {
    return `${years} ${yearsText} e ${months} ${monthsText}`;
  } else if (years > 0) {
    return `${years} ${yearsText}`;
  } else {
    return `${months} ${monthsText}`;
  }
}

function getTotalYears(startDate) {
  const now = new Date();
  const start = new Date(startDate);
  let years = now.getFullYear() - start.getFullYear();
  
  // Se o mês atual for menor que o mês de início, subtrai 1 ano
  if (now.getMonth() < start.getMonth()) {
    years--;
  }
  
  return years;
}

const animateScroll = () => {
  const sections = document.querySelectorAll(".js-show-on-scroll");
  const windowHalfSize = window.innerHeight * 0.75;

  sections.forEach((item) => {
    const sectionTop = item.getBoundingClientRect().top;
    const isSectionVisible = sectionTop - windowHalfSize < 0;

    if (isSectionVisible) {
      item.classList.add("translate-x-0");
      item.classList.add("opacity-100");
    } else {
      item.classList.remove("translate-x-0");
      item.classList.remove("opacity-100");
    }
  });
};
